/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDashboard = createReactComponent("dashboard", "IconDashboard", [
  ["path", { d: "M12 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-0" }],
  ["path", { d: "M13.45 11.55l2.05 -2.05", key: "svg-1" }],
  ["path", { d: "M6.4 20a9 9 0 1 1 11.2 0z", key: "svg-2" }]
]);

export { IconDashboard as default };
//# sourceMappingURL=IconDashboard.js.map
